import { memo } from 'react';
import { ArrowDown, Leaf, Heart } from 'lucide-react';
import { trackCTAClick } from '@/hooks/useGoogleAnalytics';

const Hero = memo(() => {
  const handleCTAClick = (ctaName: string) => {
    trackCTAClick(ctaName, 'Hero');
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen gradient-hero flex items-center justify-center overflow-hidden"
    >
      {/* Decorative blobs */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-sage-light/40 blob floating opacity-60" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-rose-light/30 blob floating opacity-50 [animation-delay:2s]" />
      <div className="absolute top-1/2 right-1/4 w-48 h-48 bg-sage/20 blob floating opacity-40 [animation-delay:4s]" />

      {/* Content */}
      <div className="container-custom relative z-10 pt-24 sm:pt-26 md:pt-28 lg:pt-32 pb-12">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main heading */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 animate-fade-up">
            <span className="text-foreground">Nutricionista </span>
            <span className="text-gradient">Clínica y Deportiva</span>
            <br />
            <span className="text-foreground">en </span>
            <span className="text-gradient">Madrid</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 animate-fade-up delay-200">
            Soy Marina González Hurtado, nutricionista y farmacéutica. 
            Te ayudo a alcanzar tus objetivos de salud con planes 
            personalizados, seguimiento constante y apoyo profesional.
          </p>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 glass px-4 py-2 rounded-full mb-6 animate-fade-up delay-300">
            <Leaf className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-muted-foreground">
              Nutricionista colegiada MAD01587
            </span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 animate-fade-up delay-400">
            <a 
              href="#contacto" 
              className="btn-primary flex items-center gap-2 text-lg px-8 py-4"
              onClick={() => handleCTAClick('Empieza ahora')}
            >
              <Heart className="w-5 h-5" />
              Empieza ahora
            </a>
            <a 
              href="#servicios" 
              className="btn-secondary flex items-center gap-2 text-lg px-8 py-4"
              onClick={() => handleCTAClick('Ver servicios')}
            >
              Ver servicios
            </a>
          </div>

        </div>

        {/* Scroll indicator */}
        <div className="flex justify-center w-full animate-fade-up delay-500">
          <a
            href="#servicios"
            className="flex flex-col items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
            onClick={() => handleCTAClick('Descubre más')}
          >
            <span className="text-sm">Descubre más</span>
            <ArrowDown className="w-5 h-5 animate-bounce" />
          </a>
        </div>
      </div>
    </section>
  );
});

Hero.displayName = 'Hero';

export default Hero;
